import tooltip from "assets/jss/material-kit-react/tooltipsStyle.jsx";
import headerLinksStyle from "assets/jss/material-kit-react/components/headerLinksStyle.jsx";
import customInput from "assets/jss/material-kit-react/components/customInputStyle.jsx";
import {
  primaryColor,
  dangerColor,
  successColor,
  defaultFont
} from "assets/jss/material-kit-react.jsx";

const joinModalStyle = theme => ({
  closeButton: {
    color: "white",
    textAlign: "center",
    position: "relative",
    padding: "0.9375rem",
    fontWeight: "500",
    fontSize: "16px",
    textTransform: "uppercase",
    borderRadius: "3px",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "flex",
    width: "100%",
    "&:hover,&:focus": {
      color: "inherit",
      background: "rgba(200, 200, 200, 0.2)"
    },
  },
  modal: {
    paddingTop: "30px",
    paddingBottom: "60px"
  }
});

export default joinModalStyle;